import { EmptyPage } from '../empty-page/EmptyPage';

export const Reports = () => {
  return <EmptyPage />;
};
